import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-providers-dropdown',
  templateUrl: './providers-dropdown.component.html',
  styleUrl: './providers-dropdown.component.scss'
})
export class ProvidersDropdownComponent {

  @Input() label: string = 'Common.ProviderName'
  @Input() isRequired:boolean = false
  @Output() setSelected: EventEmitter<any> = new EventEmitter();

  constructor(
    private fb: FormBuilder,
  ) { }

  ngOnInit(){
     if(this.isRequired){
      this.form.get('provider')?.addValidators(Validators.required)
    }
  }

  form: FormGroup = this.fb.group({
    provider: new FormControl(""),
  });

  onClick() {
    let selected = this.form.get('provider')?.value
    this.setSelected.emit(selected)
    
  }
}
